export enum ConfigLookupType {
  AUTO_PAY = <any>'AUTO_PAY',
  DEFAULT_END_DATE_PLUS_DAYS = <any>'DEFAULT_END_DATE_PLUS_DAYS',
  TRANSIENT_RESERVATIONS_MAX_RESULT = <any>'TRANSIENT_RESERVATIONS_MAX_RESULT',
  PREPAYMENT_MIN_AMOUNT = <any>'PREPAYMENT_MIN_AMOUNT',
  ALL = <any>'ALL'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-lookup-type.ts